
import {
    GET_INVOICES_SUCCESS,
    GET_INVOICES_FAIL,
    UPDATE_INVOICE_STATUS_SUCCESS,
    UPDATE_INVOICE_STATUS_FAIL,
} from "./actionTypes"

const INIT_STATE = {
    invoices: [],
    meta: {},
    error: {},
}

const invoicesAdmin = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_INVOICES_SUCCESS:
            return {
                ...state,
                invoices: action.payload.data,
                meta: {
                    current_page: action.payload.current_page,
                    last_page: action.payload.last_page,
                    total: action.payload.total
                }
            }

        case GET_INVOICES_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_INVOICE_STATUS_SUCCESS:
            return {
                ...state,
                invoices: state.invoices.map(invoice =>
                    invoice.id.toString() === action.payload.invoice.id.toString()
                        ? { ...invoice, ...action.payload.invoice }
                        : invoice
                ),
            }

        case UPDATE_INVOICE_STATUS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default invoicesAdmin
